import React, { useContext, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import { constants } from 'constants/Constants';
import KpiDefinitionDrawer from 'components/KpiDefinitionDrawer/KpiDefinitionDrawer';
import KpiDefinitionData from 'service/KpiDefinitionData';
import MetricsOverviewCard from '../../../components/MetricsOverviewCard/MetricsOverviewCard';
import { FilterContext } from 'components/FilterBar/FilterProvider';
import { useOperationalMetrics } from 'hooks/operational-metrics-hook';
import { helperFunctions } from 'utils/helperFunctions';
import { useMetricsCriteria } from 'hooks/useMetricsCriteria';
import * as Styled from './style';
import { ThemeContext } from '../../../context/ThemeContext';

interface GPGValueCreationScorecardProps {
  // Add any props if needed
}

const GPGValueCreationScorecard: React.FC<
  GPGValueCreationScorecardProps
> = () => {
  const { selectedProduct } = useContext(FilterContext);
  const { operationalMetricCriteria } = useMetricsCriteria();
  const { getGPGVCScorecardData, gpgVCScoreCardLoading, gpgVCScoreCardData } =
    useOperationalMetrics();
  const { mode } = useContext(ThemeContext);
  // Fetch GPG scorecard data
  useEffect(() => {
    const psdCriteria = { ...operationalMetricCriteria };
    getGPGVCScorecardData({ variables: { psdCriteria } });
  }, [operationalMetricCriteria, getGPGVCScorecardData]);

  const { createMetricConfig, currencyParser, percentageParser } =
    helperFunctions();

  const gpgMetricOverviewConfig = createMetricConfig([
    {
      value: gpgVCScoreCardData?.totalTransactions,
      title: 'Total Completed Payments',
    },
    {
      value: gpgVCScoreCardData?.totalAuthRatePercentage,
      valueParser: percentageParser,
      title: 'Payment Authorization Rate',
    },
    {
      value: gpgVCScoreCardData?.averageCompletedPaymentValue,
      valueParser: (value) => currencyParser(value),
      title: 'Avg Completed Payment Value',
    },
  ]);

  return (
    <Styled.DTCOverviewContainer
      data-testid="gpg-valuecreation-overview-container"
      mode={mode}
    >
      <Grid item xs={12}>
        <Typography className="header">
          {constants?.overview?.operationalMetrics}
          <KpiDefinitionDrawer
            title={constants?.overview?.operationalMetrics}
            KpiDefinitionList={
              KpiDefinitionData[selectedProduct?.productId]?.operationalMetrics
                ?.scoreCard ?? []
            }
          />
        </Typography>
        <MetricsOverviewCard
          title={''}
          metricConfig={gpgMetricOverviewConfig}
          showKpi={false}
          isLoading={gpgVCScoreCardLoading}
          KpiDefinitionList={
            KpiDefinitionData[selectedProduct?.productId]?.operationalMetrics
              ?.scoreCard ?? []
          }
          isDTC={false}
        />
      </Grid>
    </Styled.DTCOverviewContainer>
  );
};

export default GPGValueCreationScorecard;
